import { ActivatedRouteSnapshot, Data } from '@angular/router';

const CLIENT_PROCESS_KEY = 'isClientProcess';

/**
 * Se declara en las rutas donde el asesor trabaja la carpeta de un cliente ya
 * identificado. El reporte de soporte solo toma carpeta y cedula en esas
 * pantallas, porque el estado del flujo no se limpia al salir de el.
 */
export const CLIENT_PROCESS_ROUTE_DATA: Data = { [CLIENT_PROCESS_KEY]: true };

export const isClientProcessRoute = (root: ActivatedRouteSnapshot): boolean => {
  let route = root;
  while (route.firstChild) {
    route = route.firstChild;
  }
  return route.data[CLIENT_PROCESS_KEY] === true;
};
